<template>
    <div>
        <v-row >
            <v-col cols="12">
                <h2 class="mt-4">Facility Reviews</h2>
            </v-col>
            <v-col cols="12">
                <v-switch
                    data-testid="facility-reviews-visibility-switch"
                    class="facility-reviews-visibility-switch"
                    :label="currentFacility.reviews_enabled ? 'Reviews Enabled' : 'Reviews Disabled'"
                    v-model="currentFacility.reviews_enabled"
                />
            </v-col>
            <v-col>
                <v-data-table
                    :headers="headers"
                    :loading="loading"
                    :items="reviews"
                >
                    <template v-slot:body="{ items }">
                        <transition-group
                            name="scroll-y-transition"
                            tag="tbody"
                            v-if="items.length"
                        >
                            <tr v-for="item in reviews" :key="item.id">
                                <td>{{ item.first_name }}</td>
                                <td>{{ item.last_name }}</td>
                                <td>{{ item.email }}</td>
                                <td>{{ item.rating }}</td>
                                <td>
                                    <span v-if="item.featured_on_homepage === 1">Yes</span>
                                    <span v-else>No</span>
                                </td>
                                <td>
                                  <v-tooltip
                                    bottom
                                    :disabled="item.content ? item.content.length <= 50 : ''"
                                  >
                                    <template v-slot:activator="{on}">
                                      <p class="content-column mt-4" v-on="on">
                                        {{ truncateContent(item.content, 50) }}
                                      </p>
                                    </template>
                                    <span>{{ item.content }}</span>
                                  </v-tooltip>
                                </td>
                                <td>
                                    <v-row class="py-2">
                                        <toggle-review
                                          :review="item"
                                          class="mx-1"
                                        />
                                        <edit-review
                                          :review="item"
                                          class="mx-1"
                                        />
                                        <v-btn
                                            data-testid="facility-reviews-feature-btn"
                                            class="facility-reviews-feature-btn mx-1"
                                            small
                                            color="green"
                                            v-if="item.published && !item.featured_on_homepage"
                                            @click="featureReview(item.id)"
                                        >
                                            Add to Homepage
                                        </v-btn>
                                        <v-btn
                                            data-testid="facility-reviews-unfeature-btn"
                                            class="facility-reviews-unfeature-btn mx-1"
                                            small
                                            color="red"
                                            v-if="item.published && item.featured_on_homepage"
                                            @click="unfeatureReview(item.id)"
                                        >
                                            Remove from Homepage
                                        </v-btn>
                                        <v-btn
                                            data-testid="facility-reviews-delete-btn"
                                            class="facility-reviews-delete-btn mx-1"
                                            small
                                            color="red"
                                            v-if="!item.published"
                                            @click="openDelete(item)"
                                        >
                                            Delete
                                        </v-btn>
                                    </v-row>
                                </td>
                            </tr>
                        </transition-group>
                        <tr v-else>
                            <td colspan="12" style="text-align: center">
                                No facility reviews found.
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
            <delete-modal
                v-model="modal"
                @delete="deleteReview"
                :itemType="'review'"
                :advisory="advisory"
            />
        </v-row>
    </div>
</template>

<script>
import DeleteModal from "@/components/DeleteModal.vue";
import EditReview from "@/views/facility/partials/EditReview.vue";
import ToggleReview from "@/views/facility/partials/ToggleReview.vue";
import { facilityReviewsHeaders } from "@/helpers/facility/facility-reviews-data-table-headers";
import { genericAdvisory } from "@/helpers/warning-advisory-text";
import { truncateContent } from "@/helpers/functions/truncate-content";

export default {
  data() {
    return {
      advisory: genericAdvisory,
      headers: facilityReviewsHeaders,
      loading: false,
      deleteThis: false,
      modal: false,
      selectedReview: ""
    };
  },

  computed: {
    reviews() {
      return this.$store.state.facility.currentFacility.reviews;
    },
    currentFacility: {
      get() {
        return this.$store.state.facility.currentFacility;
      },

      set(newValue) {
        this.$store.commit("setCurrentFacilityData", newValue);
      }
    }
  },

  methods: {
    truncateContent: truncateContent,
    openDelete(review) {
      this.modal = true;
      this.selectedReview = review;
    },
    deleteReview() {
      this.$store.dispatch("deleteReview", this.selectedReview.id)
        .then(() => {
          this.modal = false;
          this.selectedReview = "";
        });
    },
    featureReview(id) {
      this.$store.dispatch("updateReview", {
        id: id,
        featured_on_homepage: true
      });
    },
    unfeatureReview(id) {
      this.$store.dispatch("updateReview", {
        id: id,
        featured_on_homepage: false
      });
    }
  },

  components: {
    EditReview,
    ToggleReview,
    DeleteModal
  }
};

</script>
